export const environment = {
  production: false,
  configServer: {
    apiUrl: '/api/configs',
    projectId: 'tt-common-project-dev',
   appId: 'web-app',
  },
  baseApiUrl: 'http://127.0.0.1:5001/tt-common-project-dev/asia-south1/sms_api',
  useEmulators: true,
 firebase: {
    apiKey: 'AIzaSyBjcLVfy2wRP4fPtnaIhqlenODs1p7HFVk',
    authDomain: 'tt-common-project-dev.firebaseapp.com',
    projectId: 'tt-common-project-dev',
    storageBucket: 'tt-common-project-dev.firebasestorage.app',
    messagingSenderId: '12891861518',
    appId: '1:12891861518:web:2897fdb155d2eaa085c25f',
    measurementId: 'G-1PS2EZ1683'
  },
  tenantId: 'platform',
  cashfreeMode: 'sandbox' as 'sandbox' | 'production',
};
